import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const Terms: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container py-12">
        <div className="bg-white rounded-2xl shadow-apple p-8 max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">利用規約</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">第1条（適用）</h2>
              <p className="text-gray-700">
                本規約は、ForceAI（以下「当社」）が提供するRepliGo（レプリゴ）（以下「本サービス」）の利用条件を定めるものです。
                ユーザーは本規約に同意の上、本サービスを利用するものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第2条（定義）</h2>
              <p className="text-gray-700">
                本規約において以下の用語は、それぞれ以下の意味を有するものとします：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>「ユーザー」とは、本サービスを利用する個人または法人をいいます。</li>
                <li>「コンテンツ」とは、本サービスを通じて取得・管理される口コミ情報をいいます。</li>
                <li>「AI返信文」とは、本サービスが自動生成する返信文をいいます。</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第3条（利用登録）</h2>
              <p className="text-gray-700">
                ユーザーは、本サービスを利用するにあたり、真実かつ正確な情報を登録するものとします。
                登録情報に変更が生じた場合は、速やかに更新するものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第3条の2（Google Business Profile連携）</h2>
              <p className="text-gray-700">
                本サービスの利用にあたり、ユーザーは以下の条件を満たす必要があります：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>Google Business Profileアカウントを保有していること</li>
                <li>管理対象店舗のオーナーまたは管理者権限を有していること</li>
                <li>本サービスへのGoogleアカウント連携に同意すること</li>
              </ul>
              <p className="text-gray-700 mt-2">
                ユーザーは、Googleアカウント連携により、本サービスがGoogle Business Profile APIを通じて口コミデータにアクセスすることを承諾するものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第4条（禁止事項）</h2>
              <p className="text-gray-700">ユーザーは以下の行為を行ってはならないものとします：</p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>法令または公序良俗に違反する行為</li>
                <li>本サービスの運営を妨害する行為</li>
                <li>他のユーザーに迷惑をかける行為</li>
                <li>本サービスの権利を侵害する行為</li>
                <li>その他、当社が不適切と判断する行為</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第5条（本サービスの提供）</h2>
              <p className="text-gray-700">
                本サービスは以下の機能を提供します：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>Google Business Profile APIを利用した口コミの取得・同期</li>
                <li>AIによる返信文の自動生成</li>
                <li>定型文・キーワード設定</li>
                <li>多店舗管理機能（店舗数無制限）</li>
                <li>口コミ統計・分析機能</li>
                <li>アンケート・QRコード機能</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第6条（免責事項）</h2>
              <p className="text-gray-700">
                当社は、以下の事項について一切の責任を負いません：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>本サービスの利用により生じた損害</li>
                <li>AI返信文の内容に関する責任</li>
                <li>Google Business Profile APIの仕様変更による影響</li>
                <li>Googleアカウント連携に関する問題</li>
                <li>その他、本サービスに関連して生じた損害</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第7条（知的財産権）</h2>
              <p className="text-gray-700">
                本サービスに関する知的財産権は、当社または正当な権利を有する第三者に帰属します。
                ユーザーは、本サービスを利用する権利のみを有し、本サービスに関する知的財産権を取得することはありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第8条（規約の変更）</h2>
              <p className="text-gray-700">
                当社は、必要に応じて本規約を変更することができるものとします。
                変更後の規約は、本サービス上での告知をもって効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">第9条（準拠法・管轄裁判所）</h2>
              <p className="text-gray-700">
                本規約の解釈にあたっては、日本法を準拠法とします。
                本サービスに関して紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </p>
            </section>

            <div className="text-sm text-gray-500 mt-12">
              <p>制定日：2025年5月25日</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms; 